(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["algolia-autocomplete-default-template"] && !Shopify.designMode) return;
  try {
    
  const initTabSwitcher = function () {
    document.body.addEventListener('click', handleTabClick);
  };

  const handleTabClick = function (e) {
    const clickedTab = e.target.closest('.nl__aa-Default-Template__tabs .tab');
    if (!clickedTab || clickedTab.matches('.tab--selected')) return;

    const tabsWrapper = clickedTab.closest('.nl__aa-Default-Template__tabs');
    const bodyId = clickedTab.id.replace('tab-head-', 'tab-body-');

    const tabBody = tabsWrapper.querySelector(`#${bodyId}`);
    if (!tabBody) return;

    tabsWrapper.querySelectorAll('.tab').forEach((tab) => {
      tab.classList.remove('tab--selected');
      tab.setAttribute('aria-selected', 'false');
    });
    tabsWrapper.querySelectorAll('.nl__aa-Default-Template__tab-body').forEach((body) => {
      body.classList.remove('active');
    });

    clickedTab.classList.add('tab--selected');
    clickedTab.setAttribute('aria-selected', 'true');
    tabBody.classList.add('active');
  };

  initTabSwitcher();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
